"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCustomElementsSaga = exports.loadCustomElementsWorker = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var elementsSaga_1 = require("../elements/elementsSaga");
var slice_1 = require("../store/slice");
/**
 * @internal
 */
function loadCustomElementsWorker() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeEvery([slice_1.actions.loadCustomElementsRequest.match], loadCustomElementsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.loadCustomElementsWorker = loadCustomElementsWorker;
/**
 * @internal
 */
function loadCustomElementsSaga(action) {
    var _a, correlation, options, _b, result, canceled, anotherRequest, error_1;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, correlation = _a.correlation, options = _a.options;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 8, 10, 14]);
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadCustomElementsStart({ correlation: correlation }))];
            case 2:
                _c.sent();
                return [4 /*yield*/, effects_1.race({
                        result: effects_1.call(elementsSaga_1.elementsSaga, options),
                        anotherRequest: effects_1.take(function (a) {
                            return slice_1.actions.loadCustomElementsRequest.match(a) &&
                                (correlation ? a.payload.correlation === correlation : true);
                        }),
                        canceled: effects_1.take(function (a) {
                            return slice_1.actions.loadCustomElementsCancelRequest.match(a) &&
                                (correlation ? a.payload.correlation === correlation : true);
                        }),
                    })];
            case 3:
                _b = _c.sent(), result = _b.result, canceled = _b.canceled, anotherRequest = _b.anotherRequest;
                if (!result) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadCustomElementsSuccess(tslib_1.__assign(tslib_1.__assign({}, result), { correlation: correlation })))];
            case 4:
                _c.sent();
                return [2 /*return*/, result];
            case 5:
                if (!(canceled || anotherRequest)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadCustomElementsCancel({ correlation: correlation }))];
            case 6:
                _c.sent();
                _c.label = 7;
            case 7: return [3 /*break*/, 14];
            case 8:
                error_1 = _c.sent();
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadCustomElementsError({
                        error: error_1,
                        correlation: correlation,
                    }))];
            case 9:
                _c.sent();
                return [3 /*break*/, 14];
            case 10: return [4 /*yield*/, effects_1.cancelled()];
            case 11:
                if (!_c.sent()) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.put(slice_1.actions.loadCustomElementsCancel({ correlation: correlation }))];
            case 12:
                _c.sent();
                _c.label = 13;
            case 13: return [7 /*endfinally*/];
            case 14: return [2 /*return*/];
        }
    });
}
exports.loadCustomElementsSaga = loadCustomElementsSaga;
//# sourceMappingURL=loadCustomElementsSaga.js.map